// extracted by css-extract-rspack-plugin
export default {"root":"MiniBarCell-module__root___BW4Dr"};